module.exports = __webpack_public_path__ + "img/brown.0629d16e.jpg";